function PlusIcon() {
  return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.3335 8L12.6668 8" stroke="#6E6864" strokeWidth="2" strokeLinecap="round"/>
            <path d="M8 12.6666L8 3.33329" stroke="#6E6864" strokeWidth="2" strokeLinecap="round"/>
        </svg>
  );
}

export default PlusIcon;
